import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { styled } from 'styled-components';
import { numberWithCurrency } from '@hivebrite/utils';
import { __, s__ } from "../../../i18n/src";
import { CURRENCY_DISPLAY, periodicityTranslations } from '../constants';
const NoWrapSpan = styled.span `
  white-space: 'nowrap';
`;
const getPeriodicitySuffix = ({ periodicity, }) => {
    if (!periodicity) {
        return '';
    }
    const periodicityString = periodicityTranslations[periodicity];
    if (periodicity === 'none') {
        return ` - ${periodicityString}`;
    }
    return `/${periodicityString}`;
};
export const Price = ({ currency, hasFreeTrial = false, locale, periodicity, price, renderZeroAsFree = false, }) => {
    const value = useMemo(() => {
        if (price === 0 && renderZeroAsFree) {
            return __('Free');
        }
        if (!currency) {
            throw new Error('`currency` is required if price is not 0');
        }
        return numberWithCurrency({
            currency,
            options: {
                currencyDisplay: CURRENCY_DISPLAY,
                locale,
            },
            value: price,
        });
    }, [currency, locale, price, renderZeroAsFree]);
    const periodicitySuffix = getPeriodicitySuffix({
        periodicity,
    });
    return (_jsx(NoWrapSpan, { children: hasFreeTrial
            ? s__('OrderSummary|Then %{value}%{periodicitySuffix}').i__({
                value,
                periodicitySuffix,
            })
            : `${value}${periodicitySuffix}` }));
};
//# sourceMappingURL=Price.js.map